import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { Title } from "style/components/Title.styles";
import { Button } from "components/Button";
import {
  marketplaceStrategyIdSelect,
  showFeatureDetailsKeySelect,
} from "Layout/slice/selector";
import { toggleStartGuideModal } from "Layout/slice";
import { FeatureDetailsModalContainer } from "./FeatureDetailsModal.styles";
import { FEATURE_LIST } from "../Walkthrough/walkthrough";
import { useNavigation } from "utils/navigate";
import { contains } from "utils";

const FeatureDetailsModal = ({ show, handleStart, handleHide }) => {
  const { navigateToV2 } = useNavigation();

  const dispatch = useDispatch();
  const showFeatureDetailsKey = useSelector(showFeatureDetailsKeySelect);
  const marketplaceStrategyId = useSelector(marketplaceStrategyIdSelect);

  const { title, description } = FEATURE_LIST[showFeatureDetailsKey];

  const onStart = () => {
    dispatch(toggleStartGuideModal(false));

    let pathname = FEATURE_LIST[showFeatureDetailsKey]?.path;

    if (contains(pathname, "id")) {
      pathname = pathname.replace(":id", marketplaceStrategyId);
    }

    navigateToV2(pathname);
    handleStart();
  };

  const onHide = () => {
    dispatch(toggleStartGuideModal(false));
    handleHide();
  };

  return (
    <FeatureDetailsModalContainer show={show} onHide={onHide} centered={false}>
      <div className="heading">
        <Title>{title}</Title>
      </div>
      <div className="sub-content">
        <p>{description}</p>
        <Row>
          <Col md={6}>
            <Button
              variant="secondary"
              onClick={onHide}
              className="button-outlined"
            >
              Close
            </Button>
          </Col>
          <Col md={6}>
            <Button
              onClick={onStart}
              disabled={
                !marketplaceStrategyId && showFeatureDetailsKey === "strategy"
              }
            >
              Let’s Start
            </Button>
          </Col>
        </Row>
      </div>
    </FeatureDetailsModalContainer>
  );
};

FeatureDetailsModal.propTypes = {
  show: PropTypes.bool,
  handleStart: PropTypes.func,
  handleHide: PropTypes.func,
};

export { FeatureDetailsModal };
